import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Link } from 'plurall-ui'
import style from './Link.module.css'

const LinkParagraph = ({ links }) => {
  return (
    !!links.length && (
      <div>
        {links.map(link => (
          <li key={link.url.path} className={style.link}>
            <Link href={link.url.path}>{link.title}</Link>
          </li>
        ))}
      </div>
    )
  )
}

LinkParagraph.propTypes = {
  links: PropTypes.array,
}

const fragments = {
  paragraph: gql`
    fragment LinkParagraphFragment on ParagraphLink {
      id
      links: fieldLink {
        title
        url {
          path
        }
      }
      description: fieldParagraphDescription {
        value
      }
      caption: fieldParagraphCaption {
        value
      }
      credits: fieldParagraphCredits {
        value
      }
      creditsLabel: fieldParagraphCreditsLabel
      avaliableTeacherOnly: fieldAvailableTeacherOnly
    }
  `,
}

export { LinkParagraph, fragments }
